import { usePreference } from './use-preference.ts'

/**
 * O nome que o atendente dá a um contato, só para ele (01/10).
 *
 * O dono: *"o atendente consegue editar o contato só pra ele, sem afetar o
 * dos outros"*. Fica na preferência de quem está logado (F127), no servidor:
 * vale no computador da loja e no desktop, e nenhum outro atendente vê. O
 * cadastro do cliente e o nome de perfil do WhatsApp não são tocados.
 */
export type ContactNames = {
  /** O nome que este atendente deu, ou nulo. */
  readonly nameOf: (contactId: string) => string | null
  /** Grava o nome; vazio apaga e volta ao nome de sempre. */
  readonly rename: (contactId: string, name: string) => void
  readonly error: boolean
}

export const useContactNames = (): ContactNames => {
  const preference = usePreference('inbox.contactNames', { names: {} })
  const names = preference.value.names

  return {
    nameOf: (contactId) => names[contactId] ?? null,
    rename: (contactId, name) => {
      const trimmed = name.trim().slice(0, 60)
      const next = Object.fromEntries(
        Object.entries(names).filter(([id]) => id !== contactId)
      )
      if (trimmed !== '') next[contactId] = trimmed
      preference.save({ names: next })
    },
    error: preference.error,
  }
}
